import { useParams } from 'react-router-dom';

import BillingReportForm from '@/forms/BillingReportForm';
import Container from '@/ui/components/Container';

const EditBillingReport = () => {
  const { billingReportId } = useParams<{ billingReportId: string }>();

  return (
    <Container type="page">
      <BillingReportForm reportId={billingReportId} />
    </Container>
  );
};

export default EditBillingReport;
